import { useTranslation } from 'react-i18next';
import type { MethodViewProps } from './index';

const STAGES = ['hypothesis', 'action', 'data', 'insights'] as const;

export function HadiView({ content }: MethodViewProps) {
  const { t } = useTranslation('methodologies');
  return (
    <ol className="grid grid-cols-1 xl:grid-cols-2 gap-4">
      {STAGES.map((key, index) => {
        const section = content.sections.find((item) => item.key === key);
        if (!section) return null;
        return (
          <li key={key} className="rounded-2xl bg-white p-5 md:p-6 flex flex-col gap-3 border border-[#eeeeee]">
            <div className="flex items-center gap-3">
              <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#e8f4fe] font-manrope font-bold text-[#147bc1]">{index + 1}</span>
              <h3 className="font-manrope font-semibold text-base text-[#0d0d0d]">{t(`sections.hadi.${key}`)}</h3>
            </div>
            {section.note && <p className="text-sm text-[#565858]">{section.note}</p>}
            <ul className="list-disc pl-5 space-y-2 font-segoe text-sm leading-5 text-[#0d0d0d]">
              {section.items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </li>
        );
      })}
    </ol>
  );
}
